<template>
  <v-select
    v-model="model"
    item-text="Title"
    item-value="Code"
    :items="selectItems"
    light
    flat
    outlined
    rounded
    solo
    class="rtl"
    small-chips
    required
    :label="fieldLabel"
    dense
    :prepend-inner-icon="fieldIconName"
  />
</template>

<script>
import { comboRules } from '@/lib/rules.js';

export default {
  props: {
    fieldLabel: {
      type: String,
      default: 'בחר',
      required: false,
    },
    fieldIconName: {
      type: String,
      required: false,
    },
    fieldRequired: {
      type: Boolean,
      required: false,
      default: true,
    },
    selectItems: {
      type: [Array],
      default: () => [],
      required: false,
    },
  },
  data() {
    return {
      model: {},
      comboRules,
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.model = this.selectItems[0].Code;
    },
  },

  watch: {
    model() {
      // Emit this information to the parents component
      this.$emit('child-field', this.model);
    },
  },
};
</script>
